import React from "react";
import { Link } from "react-router-dom";
import { posts } from "../data/posts";
import InsightCard from "./InsightCard";
import { SectionHeading, Reveal } from "./ui";

export default function InsightsPreview() {
  return (
    <section className="section relative overflow-hidden bg-paper">
      <div className="container-x relative">
        <div className="mb-14 flex flex-col justify-between gap-8 md:mb-20 md:flex-row md:items-end">
          <SectionHeading index="06" eyebrow="Insights" title="Engineering perspectives." className="mb-0">
            Practical viewpoints on semiconductor execution, custom silicon and the industry.
          </SectionHeading>
          <Link to="/news-blogs" className="btn-secondary shrink-0 self-start md:self-end">View all insights</Link>
        </div>
        <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {posts.map((p, i) => (
            <Reveal key={p.id} delay={i * 80}>
              <InsightCard post={p} />
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
